import type { Breadcrumb, Nullable } from '@iheartjane/types';
import type { BreadcrumbList, ListItem } from 'schema-dts';

import { jsonLD } from './jsonLD';

/**
 * @see https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
 */
export const breadcrumbList = (
  breadcrumbs: Breadcrumb[] = [],
  menuUrl?: Nullable<string>
) => {
  if (breadcrumbs.length === 0) {
    return {};
  }

  const base = menuUrl ? new URL(menuUrl) : undefined;
  const origin = base?.origin ?? '';
  const basename = base?.pathname.replace(/\/$/, '') ?? '';

  return jsonLD<BreadcrumbList>({
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map(({ title, url }, index): ListItem => {
      const listItem: ListItem = {
        '@type': 'ListItem',
        name: title,
        position: index + 1,
      };
      return url
        ? { ...listItem, item: `${origin}${basename}${url}` }
        : listItem;
    }),
  });
};
